import { ApiOperationItems } from "~enums/apiOperationItems.ts";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";
import { useExportFixturePlayByPlayFlaggedEvents } from "./useExportFixturePlayByPlayFlaggedEvents.ts";

export const useFixturePlayByPlayService = () => {
  const { mutateAsync: exportFixturePlayByPlayFlaggedEventsFn, isPending: isExportPending } = useExportFixturePlayByPlayFlaggedEvents();

  const { executeOrThrow } = useApiOperations(ApiOperationItems.FIXTURE_PLAY_BY_PLAY);

  const exportFlaggedEvents = async (fieldNames: Array<string>): Promise<DefaultOperationSuccessResponse> =>
    executeOrThrow(() => exportFixturePlayByPlayFlaggedEventsFn(fieldNames), {
      successMessageId: "fixturePBPEvent.export.started",
      isSucceeded: isDefaultOperationSucceeded,
    });

  return {
    exportFlaggedEvents,
    isExportPending,
  };
};
